import { Col, Collapse, Divider, Form as FormInicial, message, Row, Upload, Select } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    ButtonItem,
    Form,
    ModalItem,
    FormItem,
    InputItem,
    InputNumberItem,
    ErrorItem,
    HeaderItem,
    BoxItem,
    SelectItem,
    DatePickerItem,
    TextAreaItem,
} from "../../../../Components/Items";
import { DeleteOutlined, EyeOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import ModalEtiquetaLote from "../../Lotes/ModalEtiquetaLote/ModalEtiquetaLote";

const { Panel } = Collapse;
const { Option } = Select;

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

class VerLotes extends Component {
    formRef = React.createRef();
    // formRefDesplejar = React.createRef();
    state = {
        loading: false,
        loadingGuardar: false,
        archivosPorLote: {},
        previewImage: '',
        previewVisible: false,
        previewTitle: '',
        previewImageArchivo: '',
        previewVisibleArchivo: false,
        previewTitleArchivo: '',
        todasInsumosVenta: [],
        objetoInsumosVenta: null,
        modalEtiquetaLote: false,
        modalEtiquetaLoteId: null,
        insumo: null,
        loteEditandoIndex: null,
        lotesOriginales: {},
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            if (this.props.lotes) {
                this.formRef.current.setFieldsValue({ lotes: this.props.lotes })
                const archivosPorLote = {};
                this.props.lotes.forEach((lote, index) => {
                    archivosPorLote[index] = {
                        imagenes: lote.imagenes || [],
                        archivos: lote.archivos || [],
                    };
                });
                this.setState({ archivosPorLote });
            }
            if (this.props.insumoId) {
                this.consultarInsumosVentaDInsumo(this.props.insumoId);
            }
        }

    }

    consultarInsumosVentaDInsumo = async (insumoId) => {
        this.setState({ loading: true });
        await axios.post("insumos/consultarInsumosVentaDInsumo", {
            insumoId: insumoId,
            empresaId: this.props.empresaId,
        }, {
            headers: this.props.headersToken,
        }).then((res) => {
            if (res.data.success === 2) {
                this.setState({
                    todasInsumosVenta: res.data.insumos,
                    insumo: res.data.insumo,
                    objetoInsumosVenta: res.data.insumos.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.stringBuscar}
                            </Option>
                        );
                    }),
                });
            } else {
                message.error("Error al consultar la información del lote");
            }
        })
            .catch((error) => {
                console.error("Error al consultar insumos:", error);
                message.error("Error al consultar la información del lote");
            })
        await axios.post("lotes/consultarLotesInsumoComodato", {
            insumoId: insumoId,
            indexComodato: this.props.indexComodato,
            comodatoId: this.props.comodatoId,
            empresaId: this.props.empresaId,
        }, {
            headers: this.props.headersToken,
        }).then((res) => {
            if (res.data.success === 2) {
                let archivosPorLote = {};
                this.formRef.current.setFieldsValue({
                    lotes: res.data.lotes.map((lote, index) => {
                        archivosPorLote[index] = {
                            imagenes: (lote.imagenes && Array.isArray(lote.imagenes)) ? lote.imagenes.map(valueImg => {
                                return {
                                    ...valueImg,
                                    url: valueImg.url ? ("../" + valueImg.url) : "",
                                }
                            }) : [],
                            archivos: (lote.archivos && Array.isArray(lote.archivos)) ? lote.archivos.map(valueArch => {
                                return {
                                    ...valueArch,
                                    url: valueArch.url ? ((process.env.NODE_ENV === "development" ? "http://192.168.100.6:3001/../" : "../") + valueArch.url) : "",
                                }
                            }) : [],
                        };
                        return {
                            ...lote,
                            fechaIngresoM: lote.fechaIngresoM ? moment(lote.fechaIngresoM) : null,
                            fechaEntrega: lote.fechaEntrega ? moment(lote.fechaEntrega) : null,
                            fechaPedimento: lote.fechaPedimento ? moment(lote.fechaPedimento) : null,
                            caducidad: lote.caducidad ? moment(lote.caducidad) : null,
                        }
                    })
                });
                this.setState({ archivosPorLote, insumo: res.data.insumo });
            } else {
                message.error("Error al consultar la información del lote");
            }
        })
            .catch((error) => {
                console.error("Error al consultar insumos:", error);
                message.error("Error al consultar la información del lote");
            })
        this.setState({ loading: false });
    }

    cerrarVerLotes() {
        const lotes = this.formRef.current.getFieldValue('lotes') || [];

        const lotesConArchivos = lotes.map((lote, index) => {
            const archivos = this.state.archivosPorLote[index] || {};
            return {
                ...lote,
                imagenes: archivos.imagenes || [],
                archivos: archivos.archivos || [],
            };
        });

        this.props.cerrarVerLotes(lotesConArchivos);
        this.setState({ archivosPorLote: {}, loteEditandoIndex: null, lotesOriginales: {} });
        this.formRef.current.resetFields();
    }

    onFinish() {
        this.cerrarVerLotes()
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    // onFinishDesplejar(e) {
    //     if (e.inicio < e.final) {
    //         let arrayLotes = []
    //         for (let i = e.inicio; i <= e.final; i++) {
    //             arrayLotes.push({
    //                 numero: i,
    //                 cantidad: e.cantidad
    //             })
    //         }
    //         const lotesActuales = this.formRef.current.getFieldValue('lotes')
    //         if (lotesActuales && lotesActuales?.length > 0) {
    //             this.formRef.current.setFieldsValue({ lotes: [...lotesActuales, ...arrayLotes] })
    //         } else {
    //             this.formRef.current.setFieldsValue({ lotes: arrayLotes })
    //         }
    //         this.formRefDesplejar.current.resetFields()
    //     } else {
    //         message.warning('El inicio tiene que ser menor que el final')
    //     }
    // }

    // onFinishFailedDesplejar(e) {
    //     ErrorItem(e);
    // }

    async customRequestImagenes(loteIndex, e) {
        const file = e.file;
        const isImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
        const isLt5M = file.size / 1024 / 1024 < 25;

        if (!isImage) {
            message.error(`${file.name} no es un tipo de imagen válido`);
            e.onError('Tipo de archivo inválido');
            return;
        }

        if (!isLt5M) {
            message.error(`${file.name} supera los 25 MB`);
            e.onError('Archivo demasiado grande');
            return;
        }

        const base64 = await getBase64(file);

        const newFile = {
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: base64, // Esto permite mostrar la imagen y hacer preview
            originFileObj: file,
        };

        this.setState((prev) => {
            const anterior = prev.archivosPorLote[loteIndex]?.imagenes || [];
            return {
                archivosPorLote: {
                    ...prev.archivosPorLote,
                    [loteIndex]: {
                        ...prev.archivosPorLote[loteIndex],
                        imagenes: [...anterior, newFile],
                    },
                },
            };
        });

        e.onSuccess("ok");
    }

    beforeUploadImagenes(file) {
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp';
        if (!isImage) {
            message.error(`${file.name} no es un tipo de imagen válido (JPEG/PNG/WEBP)`);
            return Upload.LIST_IGNORE;
        }

        const isLt5M = file.size / 1024 / 1024 < 25;
        if (!isLt5M) {
            message.error(`${file.name} excede el tamaño máximo de 25MB`);
            return Upload.LIST_IGNORE;
        }

        return true;
    }

    onRemoveFileImagenes = (index, file) => {
        const archivos = this.state.archivosPorLote[index]?.imagenes || [];
        const filtrado = archivos.filter((item) => item.uid !== file.uid);

        this.setState((prev) => ({
            archivosPorLote: {
                ...prev.archivosPorLote,
                [index]: {
                    ...prev.archivosPorLote[index],
                    imagenes: filtrado,
                },
            },
        }));
    };

    handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || '',
        });
    };

    handleCancel = () => this.setState({ previewVisible: false });

    customRequestArchivos = async (index, e) => {
        const file = e.file;
        const isPDF = file.type === 'application/pdf';
        const isLt5M = file.size / 1024 / 1024 < 25;

        if (!isPDF) {
            message.error(`${file.name} no es un archivo PDF válido`);
            e.onError('Tipo de archivo inválido');
            return;
        }

        if (!isLt5M) {
            message.error(`${file.name} supera los 25 MB`);
            e.onError('Archivo demasiado grande');
            return;
        }

        const base64 = await getBase64(file);

        const nuevoArchivo = {
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: base64,
            originFileObj: file,
        };

        this.setState((prev) => {
            const anteriores = prev.archivosPorLote[index]?.archivos || [];
            return {
                archivosPorLote: {
                    ...prev.archivosPorLote,
                    [index]: {
                        ...prev.archivosPorLote[index],
                        archivos: [...anteriores, nuevoArchivo],
                    },
                },
            };
        });

        e.onSuccess("ok");
    };

    beforeUploadArchivos = (file) => {
        const isPDF = file.type === 'application/pdf';
        const isLt5M = file.size / 1024 / 1024 < 25;

        if (!isPDF) {
            message.error(`${file.name} no es un archivo PDF válido`);
            return Upload.LIST_IGNORE;
        }

        if (!isLt5M) {
            message.error(`${file.name} excede el tamaño máximo de 25MB`);
            return Upload.LIST_IGNORE;
        }

        return true;
    };

    onRemoveFileArchivos = (index, file) => {
        const archivos = this.state.archivosPorLote[index]?.archivos || [];
        const filtrado = archivos.filter((item) => item.uid !== file.uid);

        this.setState((prev) => ({
            archivosPorLote: {
                ...prev.archivosPorLote,
                [index]: {
                    ...prev.archivosPorLote[index],
                    archivos: filtrado,
                },
            },
        }));
    };

    handlePreviewArchivo = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        this.setState({
            previewImageArchivo: file.url || file.preview,
            previewVisibleArchivo: true,
            previewTitleArchivo: file.name || '',
        },);
    };

    handleCancelArchivo = () => this.setState({ previewVisibleArchivo: false });

    quitarArchivos = (index) => {
        this.setState((prev) => {
            return {
                archivosPorLote: {
                    ...prev.archivosPorLote,
                    [index]: {
                        imagenes: [],
                        archivos: [],
                    },
                },
            };
        });
    }

    abrirEtiquetaLote(loteId) {
        this.setState({
            modalEtiquetaLote: true,
            modalEtiquetaLoteId: loteId,
        })
    }

    cerrarEtiquetaLote() {
        this.setState({
            modalEtiquetaLote: false,
            modalEtiquetaLoteId: null,
        })
    }

    activarEdicion(arrayKey) {
        if (this.state.loteEditandoIndex !== null) return;
        const lotes = this.formRef.current.getFieldValue('lotes');
        const loteOriginal = lotes ? { ...lotes[arrayKey] } : {};
        const archivosOriginales = this.state.archivosPorLote[arrayKey]
            ? {
                imagenes: [...(this.state.archivosPorLote[arrayKey].imagenes || [])],
                archivos: [...(this.state.archivosPorLote[arrayKey].archivos || [])],
            }
            : { imagenes: [], archivos: [] };
        this.setState((prev) => ({
            loteEditandoIndex: arrayKey,
            lotesOriginales: {
                ...prev.lotesOriginales,
                [arrayKey]: { lote: loteOriginal, archivos: archivosOriginales },
            },
        }));
    }

    cancelarEdicion(arrayKey) {
        const original = this.state.lotesOriginales[arrayKey];
        if (original) {
            const lotes = this.formRef.current.getFieldValue('lotes');
            const nuevosLotes = lotes ? [...lotes] : [];
            nuevosLotes[arrayKey] = original.lote;
            this.formRef.current.setFieldsValue({ lotes: nuevosLotes });
            this.setState((prev) => ({
                archivosPorLote: {
                    ...prev.archivosPorLote,
                    [arrayKey]: original.archivos,
                },
            }));
        }
        this.setState({ loteEditandoIndex: null });
    }

    guardarLote(arrayKey) {
        const lotes = this.formRef.current.getFieldValue('lotes');
        const lote = lotes ? lotes[arrayKey] : {};
        const archivos = this.state.archivosPorLote[arrayKey] || {};
        this.setState({ loadingGuardar: true });
        axios.post("lotes/editarLote", {
            loteId: lote._id,
            empresaId: this.props.empresaId,
            ...lote,
            archivos: archivos.archivos || [],
            imagenes: archivos.imagenes || [],
        }, {
            headers: this.props.headersToken,
        }).then((res) => {
            this.setState({ loadingGuardar: false });
            if (res.data.success === 2) {
                message.success("Lote editado correctamente");
                this.setState({ loteEditandoIndex: null });
            } else {
                message.error("Error al editar el lote");
            }
        }).catch(() => {
            this.setState({ loadingGuardar: false });
            message.error("Error al editar el lote");
        });
    }

    render() {
        const nombreInsumo = this.state.insumo?.descripcion || "";
        const codigoInsumo = this.state.insumo?.clave ? `${this.state.insumo.clave}` : "";
        const tituloExtra = nombreInsumo ? ` : ${codigoInsumo} - ${nombreInsumo}` : "";
        const tituloModal = (this.props.taxidermia ? "Ver Animales" : "Ver Lotes") + tituloExtra;

        return (
            <>
                <ModalItem
                    title={tituloModal}
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarVerLotes.bind(this)}
                    paddingTop
                    width={1000}
                >
                    <Divider>{this.props.taxidermia ? "Animales" : "Lotes"}</Divider>
                    <Form
                        ref={this.formRef}
                        name="verLote"
                        layout
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormInicial.List name="lotes">
                            {(fields) => (
                                <>
                                    <Collapse>
                                        {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => {
                                            const lotes = this.formRef.current.getFieldValue('lotes');
                                            const lote = lotes ? lotes[arrayKey] : {};
                                            return (
                                                <Panel
                                                    header={this.props.taxidermia ? `Animal ${lote?.numero ? lote?.numero : ""}` : `Lote ${lote?.numero ? lote?.numero : ""}`}
                                                    key={arrayKey}
                                                    extra={
                                                        <div style={{ display: 'flex', gap: 8 }} onClick={(e) => e.stopPropagation()}>
                                                            {this.props.taxidermia && (
                                                                <ButtonItem
                                                                    type="primary"
                                                                    blanco
                                                                    onClick={() => this.abrirEtiquetaLote(lote?.entradaId)}
                                                                >
                                                                    Etiqueta
                                                                </ButtonItem>
                                                            )}
                                                            {this.state.loteEditandoIndex === arrayKey ? (
                                                                <>
                                                                    <ButtonItem
                                                                        type="primary"
                                                                        loading={this.state.loadingGuardar}
                                                                        onClick={() => this.guardarLote(arrayKey)}
                                                                    >
                                                                        Guardar
                                                                    </ButtonItem>
                                                                    <ButtonItem
                                                                        onClick={() => this.cancelarEdicion(arrayKey)}
                                                                        disabled={this.state.loadingGuardar}
                                                                    >
                                                                        Cancelar
                                                                    </ButtonItem>
                                                                </>
                                                            ) : (
                                                                <ButtonItem
                                                                    type="primary"
                                                                    blanco
                                                                    disabled={this.state.loteEditandoIndex !== null}
                                                                    onClick={() => this.activarEdicion(arrayKey)}
                                                                >
                                                                    Editar
                                                                </ButtonItem>
                                                            )}
                                                        </div>
                                                    }
                                                >
                                                    <Row key={arrayKey}>
                                                        <Col span={12}>
                                                            <FormItem
                                                                {...restField}
                                                                label="Numero"
                                                                name={[name, "numero"]}
                                                                fieldKey={[fieldKey, "numero"]}
                                                                required
                                                                margin
                                                            >
                                                                <InputItem disabled placeholder="Ej. 210158" />
                                                            </FormItem>
                                                            <FormItem
                                                                {...restField}
                                                                label="Fecha Caducidad"
                                                                name={[name, "caducidad"]}
                                                                fieldKey={[fieldKey, "caducidad"]}
                                                                margin
                                                            >
                                                                <DatePickerItem
                                                                    disabled={this.state.loteEditandoIndex !== arrayKey}
                                                                    placeholder="Fecha de Caducidad"
                                                                    style={{ width: "100%" }}
                                                                    format="DD/MM/YYYY"
                                                                />
                                                            </FormItem>
                                                            {this.props.taxidermia && (
                                                                <>
                                                                    <FormItem
                                                                        {...restField}
                                                                        label="Tipo Especie"
                                                                        name={[name, "tipoEspecie"]}
                                                                        fieldKey={[fieldKey, "tipoEspecie"]}
                                                                        margin
                                                                    >
                                                                        <InputItem disabled={this.state.loteEditandoIndex !== arrayKey} placeholder="Ej. León africano" />
                                                                    </FormItem>
                                                                    <FormItem
                                                                        {...restField}
                                                                        label="Fecha Ingreso"
                                                                        name={[name, "fechaIngresoM"]}
                                                                        fieldKey={[fieldKey, "fechaIngresoM"]}
                                                                        margin
                                                                        initialValue={moment()}
                                                                    >
                                                                        <DatePickerItem
                                                                            disabled
                                                                            placeholder="Fecha Ingreso Mexico"
                                                                            style={{ width: '100%' }}
                                                                            format="DD/MM/YYYY"
                                                                        />
                                                                    </FormItem>
                                                                </>
                                                            )}
                                                        </Col>
                                                        <Col span={12}>
                                                            <FormItem
                                                                {...restField}
                                                                label="Cantidad"
                                                                name={[name, "cantidad"]}
                                                                fieldKey={[fieldKey, "cantidad"]}
                                                                required
                                                                margin
                                                                initialValue={this.props.taxidermia ? 1 : undefined}
                                                            >
                                                                <InputNumberItem disabled placeholder="Cantidad" />
                                                            </FormItem>
                                                            {this.props.taxidermia && (
                                                                <>
                                                                    <FormItem
                                                                        {...restField}
                                                                        label="Tipo Permiso"
                                                                        name={[name, "tipoPermiso"]}
                                                                        fieldKey={[fieldKey, "tipoPermiso"]}
                                                                        margin
                                                                    >
                                                                        <SelectItem disabled={this.state.loteEditandoIndex !== arrayKey} placeholder="Tipo de Permiso">
                                                                            <Option value="SEMARNAT">SEMARNAT</Option>
                                                                            <Option value="CINTILLO">CINTILLO</Option>
                                                                            <Option value="CITES">CITES</Option>
                                                                            <Option value="APROVECHAMIENTO">APROVECHAMIENTO</Option>
                                                                        </SelectItem>
                                                                    </FormItem>
                                                                    <FormItem
                                                                        label="Permiso"
                                                                        name={[name, "permisoCaza"]}
                                                                        fieldKey={[fieldKey, "permisoCaza"]}
                                                                        margin
                                                                    >
                                                                        <InputItem disabled={this.state.loteEditandoIndex !== arrayKey} placeholder="Permiso" />
                                                                    </FormItem>
                                                                </>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                    {this.state?.insumo?.vehiculo && (
                                                        <Row>
                                                            <Col span={12}>
                                                                <FormItem
                                                                    {...restField}
                                                                    label="Color"
                                                                    name={[name, "color"]}
                                                                    fieldKey={[fieldKey, "color"]}
                                                                    margin
                                                                >
                                                                    <InputItem disabled={this.state.loteEditandoIndex !== arrayKey} placeholder="Ej. Rojo metálico" />
                                                                </FormItem>

                                                                <FormItem
                                                                    {...restField}
                                                                    label="NIV"
                                                                    name={[name, "niv"]}
                                                                    fieldKey={[fieldKey, "niv"]}
                                                                    margin
                                                                >
                                                                    <InputItem disabled={this.state.loteEditandoIndex !== arrayKey} placeholder="Ej. 3GNAXSEFXKS123456" />
                                                                </FormItem>

                                                                <FormItem
                                                                    {...restField}
                                                                    label="No. Motor"
                                                                    name={[name, "numeroMotor"]}
                                                                    fieldKey={[fieldKey, "numeroMotor"]}
                                                                    margin
                                                                >
                                                                    <InputItem disabled={this.state.loteEditandoIndex !== arrayKey} placeholder="Número de motor" />
                                                                </FormItem>
                                                            </Col>

                                                            <Col span={12}>
                                                                <FormItem
                                                                    {...restField}
                                                                    label="Pedimento"
                                                                    name={[name, "numeroPedimento"]}
                                                                    fieldKey={[fieldKey, "numeroPedimento"]}
                                                                    margin
                                                                >
                                                                    <InputItem disabled={this.state.loteEditandoIndex !== arrayKey} placeholder="Número de pedimento" />
                                                                </FormItem>

                                                                <FormItem
                                                                    {...restField}
                                                                    label="Fecha Pedimento"
                                                                    name={[name, "fechaPedimento"]}
                                                                    fieldKey={[fieldKey, "fechaPedimento"]}
                                                                    margin
                                                                >
                                                                    <DatePickerItem
                                                                        disabled={this.state.loteEditandoIndex !== arrayKey}
                                                                        placeholder="Fecha de pedimento"
                                                                        style={{ width: "100%" }}
                                                                        format="DD/MM/YYYY"
                                                                    />
                                                                </FormItem>

                                                                <FormItem
                                                                    {...restField}
                                                                    label="Aduana"
                                                                    name={[name, "aduana"]}
                                                                    fieldKey={[fieldKey, "aduana"]}
                                                                    margin
                                                                >
                                                                    <InputItem disabled={this.state.loteEditandoIndex !== arrayKey} placeholder="Ej. Manzanillo" />
                                                                </FormItem>

                                                                <FormItem
                                                                    {...restField}
                                                                    label="Clave Vehicular"
                                                                    name={[name, "claveVehicular"]}
                                                                    fieldKey={[fieldKey, "claveVehicular"]}
                                                                    margin
                                                                >
                                                                    <InputItem disabled={this.state.loteEditandoIndex !== arrayKey} placeholder="Clave vehicular SAT" />
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    {this.props.taxidermia && (
                                                        <>
                                                            <HeaderItem>PIEZAS</HeaderItem>
                                                            <BoxItem>
                                                                <FormInicial.List name={[name, "piezas"]}>
                                                                    {(piezasFields, { add: addPieza, remove: removePieza }) => (
                                                                        <>
                                                                            {piezasFields.map(({ key: piezaKey, name: piezaName, fieldKey: piezaFieldKey, ...piezaRestField }, piezaArrayKey) => (
                                                                                <Row key={piezaArrayKey}>
                                                                                    <Col span={11}>
                                                                                        <FormItem
                                                                                            {...piezaRestField}
                                                                                            label="Pieza"
                                                                                            name={[piezaName, "descripcion"]}
                                                                                            fieldKey={[piezaFieldKey, "descripcion"]}
                                                                                            required
                                                                                            margin
                                                                                        >
                                                                                            <SelectItem disabled={this.state.loteEditandoIndex !== arrayKey} placeholder="Pieza">
                                                                                                <Option value="Entero">Entero</Option>
                                                                                                <Option value="Copina">Copina</Option>
                                                                                                <Option value="Medio Cuerpo">Medio Cuerpo</Option>
                                                                                                <Option value="Backskin">Backskin</Option>
                                                                                                <Option value="Panel">Panel</Option>
                                                                                                <Option value="Cuernos">Cuernos</Option>
                                                                                                <Option value="Craneo">Craneo</Option>
                                                                                                <Option value="Huesos">Huesos</Option>
                                                                                                <Option value="Cola">Cola</Option>
                                                                                                <Option value="Patas">Patas</Option>
                                                                                                <Option value="Colmillos">Colmillos</Option>
                                                                                                <Option value="Garras">Garras</Option>
                                                                                            </SelectItem>
                                                                                        </FormItem>
                                                                                    </Col>
                                                                                    <Col span={11}>
                                                                                        <FormItem
                                                                                            {...piezaRestField}
                                                                                            label="Cantidad"
                                                                                            name={[piezaName, "cantidad"]}
                                                                                            fieldKey={[piezaFieldKey, "cantidad"]}
                                                                                            required
                                                                                            margin
                                                                                        >
                                                                                            <InputNumberItem disabled placeholder="Cantidad" />
                                                                                        </FormItem>
                                                                                    </Col>
                                                                                </Row>
                                                                            ))}
                                                                        </>
                                                                    )}
                                                                </FormInicial.List>
                                                            </BoxItem>
                                                        </>
                                                    )}
                                                    <HeaderItem>OBSERVACIONES</HeaderItem>
                                                    <BoxItem>
                                                        <Row>
                                                            <Col span={24}>
                                                                <FormItem
                                                                    {...restField}
                                                                    label="Observaciones"
                                                                    name={[name, "observaciones"]}
                                                                    fieldKey={[fieldKey, "observaciones"]}
                                                                    margin
                                                                    labelCol={{ span: 4 }}
                                                                    wrapperCol={{ span: 20 }}
                                                                >
                                                                    <TextAreaItem
                                                                        disabled={this.state.loteEditandoIndex !== arrayKey}
                                                                        placeholder="Observaciones"
                                                                    />
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                    </BoxItem>
                                                    <HeaderItem>ARCHIVO GRAFICO</HeaderItem>
                                                    <BoxItem>
                                                        <Row>
                                                            <Col span={12}>
                                                                <FormItem
                                                                    {...restField}
                                                                    name={[name, "archivos"]}
                                                                    fieldKey={[fieldKey, "archivos"]}
                                                                    margin
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    <Upload
                                                                        accept=".pdf"
                                                                        showUploadList={{
                                                                            showRemoveIcon: true,
                                                                            showPreviewIcon: true,
                                                                            previewIcon: <EyeOutlined style={{ color: '#1890ff' }} />,
                                                                            removeIcon: <DeleteOutlined style={{ color: 'red' }} />,
                                                                        }}
                                                                        fileList={this.state.archivosPorLote[arrayKey]?.archivos || []}
                                                                        customRequest={(e) => this.customRequestArchivos(arrayKey, e)}
                                                                        beforeUpload={this.beforeUploadArchivos}
                                                                        onRemove={(file) => this.onRemoveFileArchivos(arrayKey, file)}
                                                                        onPreview={this.handlePreviewArchivo.bind(this)}
                                                                        disabled={this.state.loteEditandoIndex !== arrayKey}
                                                                    >
                                                                        {this.state.archivosPorLote[arrayKey]?.archivos?.length >= (this.props.taxidermia ? 5 : 3) ? null :
                                                                            <ButtonItem disabled={this.state.loteEditandoIndex !== arrayKey} icon={<UploadOutlined />} style={{ padding: '0px 20px' }}>
                                                                                Archivos
                                                                            </ButtonItem>
                                                                        }
                                                                    </Upload>
                                                                </FormItem>
                                                            </Col>
                                                            <Col span={12}>
                                                                <FormItem
                                                                    name={[name, "imagenes"]}
                                                                    fieldKey={[fieldKey, "imagenes"]}
                                                                    margin
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    <Upload
                                                                        accept=".jpg,.jpeg,.png,.webp"
                                                                        listType="picture-card"
                                                                        fileList={this.state.archivosPorLote[arrayKey]?.imagenes || []}
                                                                        customRequest={(e) => this.customRequestImagenes(arrayKey, e)}
                                                                        beforeUpload={this.beforeUploadImagenes}
                                                                        onRemove={(file) => this.onRemoveFileImagenes(arrayKey, file)}
                                                                        onPreview={this.handlePreview.bind(this)}
                                                                        disabled={this.state.loteEditandoIndex !== arrayKey}
                                                                    >
                                                                        {this.state.archivosPorLote[arrayKey]?.imagenes?.length >= (this.props.taxidermia ? 10 : 3) ? null :
                                                                            <div>
                                                                                <PlusOutlined />
                                                                                <div style={{ marginTop: 8 }}>Imagenes</div>
                                                                            </div>
                                                                        }
                                                                    </Upload>
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                    </BoxItem>

                                                </Panel>
                                            )
                                        })}
                                    </Collapse>
                                </>
                            )}
                        </FormInicial.List>
                    </Form>
                    <ModalItem
                        visible={this.state.previewVisible}
                        title={this.state.previewTitle}
                        footer={null}
                        onCancel={this.handleCancel}
                        spinning={false}
                    >
                        <img alt="example" style={{ width: "100%" }} src={this.state.previewImage} />
                    </ModalItem>
                    <ModalItem
                        visible={this.state.previewVisibleArchivo}
                        title={this.state.previewTitleArchivo}
                        footer={null}
                        onCancel={this.handleCancelArchivo}
                        spinning={false}
                    >
                        <iframe
                            src={this.state.previewImageArchivo}
                            title="Vista previa PDF"
                            style={{ width: '100%', height: '80vh', border: 'none' }}
                        />
                    </ModalItem>
                    <ModalEtiquetaLote
                        visible={this.state.modalEtiquetaLote}
                        loteId={this.state.modalEtiquetaLoteId}
                        cerrarModalEtiquetaLote={this.cerrarEtiquetaLote.bind(this)}
                        taxidermia={this.props.taxidermia}
                    />
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(VerLotes);
